<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Block / Unblock Learner Result </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col cols="12" md="2" sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="current_academic_year" :items="academic_year_list"
                        item-text="ay" return-object label="Academic Year" outlined persistent-hint
                        hint="Please Select Academic Year"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="std" :items="standard_list" item-text="standard"
                        item-value="id" label="Standard" outlined @change="getStandard()" persistent-hint
                        hint="Please Select Standard"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" sm="2" v-if="std != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="div" :items="dision_list" item-text="div_name"
                        item-value="div_off_id" label="Division" outlined persistent-hint
                        hint="Please Select Division"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                        item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col cols="12" md="2" sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="block_unblock"
                        :items="block_unblock_list" item-text="name" item-value="id" label="Block / Unblock Status"
                        outlined persistent-hint hint="Select Block / Unblock Status" />
                </v-col>
                <v-col sm="2">
                    <v-btn rounded class="button mt-6" v-if="status && block_unblock" @click="getAllReport()"
                        :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <!-- simpletableExportbtn -->
            <v-row dense v-if="learner_info != ''">
                <v-col cols="12" sm="6" md="6">
                    <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'BlockUnblockResult')"
                        :loading="loader"> <v-icon color="success">mdi-export</v-icon>Export </v-btn>
                </v-col>
                <!-- search code shiv -->
                <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="search1" append-icon="mdi-magnify"
                        label="Search by Student name or by Registration Number" single-line
                        hide-details></v-text-field>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="learner_info != ''">
                <!-- <strong> Note: If checked then its block student and if unchecked its unblock student</strong> -->
                <div id="my-table-id">
                    <v-simple-table fixed-header dense class="elevation-1" height="500px">
                        <thead>
                            <tr>
                                <th align="center">
                                    <label class="form-checkbox">
                                        <input type="checkbox" v-model="selectAll" @click="select()" />
                                        <i class="form-icon"></i>
                                    </label>
                                </th>
                                <th class="">Sr. No.</th>
                                <th class="">Registration No.</th>
                                <th class="">Name</th>
                                <th class="">Mobile No.</th>
                                <th class="">Quota</th>
                                <th class="">Academic Year</th>
                                <th class="">Admission Year</th>
                                <th class="">Standard</th>
                                <th class="">Division</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr></tr>
                            <tr v-for="s in filteredItems" :key="s.id">
                                <!-- <tr v-for="s in learner_info" :key="s.id"> -->
                                <td>
                                    <label class="form-checkbox">
                                        <input type="checkbox" :value="s.id" v-model="s.block_status" />
                                        <i class="form-icon"></i>
                                    </label>
                                </td>
                                <td>{{ s.sr_no }}</td>
                                <td>{{ s.reg_no }}</td>
                                <td>{{ s.name }}</td>
                                <td>{{ s.primary_contact_number }}</td>
                                <td>{{ s.quota }}</td>
                                <td>{{ s.academicyear }}</td>
                                <td>{{ s.learner_addmission_year }}</td>
                                <td>{{ s.standard }}</td>
                                <td>{{ s.div }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <v-col cols="12" md="12" sm="12">
                    <center>
                        <v-btn rounded class="button mt-6" :loading="loader" v-if="learner_info != ''"
                            @click="saveBlockUnblockResult(learner_info)">Unblock / Block Student Result</v-btn>
                    </center>
                </v-col>
            </v-col>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },

        data() {
            return {
                loader: false,
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                color: "",
                snackbar: false,
                search: "",
                snackbar_msg: null,
                current_academic_year: null,
                div: null,
                std: "",
                header: null,
                academic_year_list: null,
                standard_list: null,
                dision_list: null,
                learner_info: [],
                show: false,
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,
                block_unblock_list: [
                    { name: "Show Block Students", id: "0" },
                    { name: "Show Unblock Students", id: "1" },
                ],
                block_unblock: null,
                overlay: false,
                selected: [],
                selectAll: false,
                search1: "",
            };
        },
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const filename = name + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },
            select() {
                this.selected = [];
                for (let i in this.learner_info) {
                    this.learner_info[i].block_status = false;
                }
                if (!this.selectAll) {
                    for (let i in this.learner_info) {
                        this.selected.push(this.learner_info[i].id);
                        this.learner_info[i].block_status = true;
                    }
                }

                // this.selected = [];
                // if (!this.learner_info) {
                //     for (let i in this.learner_info) {
                //         this.selected.push(this.learner_info[i]);
                //     }
                // }
            },
            saveBlockUnblockResult(learner_info) {
                const data = {
                    learner_info: learner_info,
                };
                this.loader = true;
                axios
                    .post("/Examination/saveBlockUnblockResult", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Save successfully");
                            this.getAllReport();
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.loader = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.loader = false;
                    })
                    .finally(() => {});
            },
            getAllReport() {
                const data = {
                    status: this.status,
                    block_unblock: this.block_unblock,
                    div: this.div,
                    ay: this.current_academic_year.id,
                    std: this.std,
                };
                this.overlay = true;
                axios
                    .post("/Examination/getBlockUnblockData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_info = res.data.learner_info;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.fmsg);
                            this.overlay = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.overlay = false;
                    })
                    .finally(() => {});
            },
            getStandard() {
                const data = {
                    ay: this.current_academic_year.id,
                    std: this.std,
                };
                axios
                    .post("/InstallmentStructureDetails/getStandard", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.dision_list = res.data.dision_list;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/InstallmentStructureDetails/getAllData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.academic_year_list = res.data.ay_data;
                            this.current_academic_year = res.data.cay;
                            this.standard_list = res.data.standard_list;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.get_ay_std_ft_loader = false;
                    });
            },
        },
        mounted() {
            this.onload();
        },
        computed: {
            filteredItems() {
                return this.learner_info.filter((item) => {
                    return item.name.toLowerCase().indexOf(this.search1.toLowerCase()) > -1 || item.reg_no.toLowerCase().indexOf(this.search1.toLowerCase()) > -1;
                });
            },
        },
    };
</script>
<style scoped>
    .scroll {
        overflow-x: scroll;
    }
    .text-color {
        font-weight: bold;
        color: red;
        font-size: small;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .mytable2 /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
